import React from "react";

import { ContactUsAlert } from "Components/Form/Alert";

import { AlertTitle } from "Components/TextContext/commonComponentEnums";

import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { useFormikContext } from "formik";
import { useFeatureToggle } from "Store/featureToggles/featureToggleHooks";
import { FeatureToggle } from "Store/featureToggles/featureToggleTypes";
import { useDebounce } from "Utils/debounce/useDebounce";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { getCarOwnerOptions } from "../../ProductDetails/FormElements/formElementsOptions";
import { CarOwner } from "../../ProductDetails/FormElements/interfaces";
import { CarPriceFormValues } from "../interfaces";

interface Props {
  updatePrices: (field: string, value: number | string) => void;
}

export const CarOwnerFields = (props: Props): React.ReactElement => {
  const debounce = useDebounce(1000);
  const formProps = useFormikContext<CarPriceFormValues>();
  const { getText } = useTexts();
  const { updatePrices } = props;
  const blockingPage = useFeatureToggle(FeatureToggle.BLOCKING_PAGE);

  return (
    <>
      <Select
        id="carOwner"
        name="carOwner"
        label={getText("carform.label.carowner")}
        options={getCarOwnerOptions(getText)}
        error={getError("carOwner", formProps)}
        onChange={(event) => {
          const { name, value } = event.target;
          const leasingOrCustomerIsOwner =
            value === CarOwner.LEASING || value === CarOwner.MYSELF;
          const shouldUpdatePrices =
            (isDefined(formProps.values.carOwnerAge) ||
              leasingOrCustomerIsOwner) &&
            value !== CarOwner.OTHER;

          if (isDefined(event) && shouldUpdatePrices) {
            updatePrices(name, value);
          }
        }}
        large
      />

      {formProps.values.carOwner === CarOwner.OTHER && !blockingPage && (
        <ContactUsAlert
          title={getText(AlertTitle.CALL_US)}
          description={getText("carform.alertdescription.ownercantbuy")}
          alertId="invalidVehicleOwner"
          variant="border"
          marginBottom="32px"
        />
      )}

      {(formProps.values.carOwner === CarOwner.PARTNER ||
        formProps.values.carOwner === CarOwner.GUARDIAN) && (
        <NumericInput
          name="carOwnerAge"
          id="carOwnerAge"
          label={getText("carform.label.ownerage")}
          error={getError("carOwnerAge", formProps)}
          large
          inputMode={InputMode.NUMERIC}
          onChange={(age) => {
            debounce(() => {
              if (isDefined(age.floatValue)) {
                updatePrices("carOwnerAge", age.floatValue);
              }
            });
          }}
        />
      )}
    </>
  );
};
